<template>
  <div class="header">
    <el-menu mode="horizontal" @select="handleSelect">
      <div class="logo">
        <i class="el-icon-location"></i> SANYUAN
      </div>
      <el-submenu class="right-menu" index="1">
        <template slot="title">{{username}}</template>
        <el-menu-item index="2-1"><a class="logout" v-bind:href="rootPath + '/'" target="_self">退出登录</a></el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="line"></div>
  </div>

</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        activeIndex: '1',
        username: 'sinsun', //window._$base.userInfo.userName,
        rootPath: '..'//window._$base.rootPath
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }

    },
    created: function() {
      var that = this;
    }
  }

</script>
<style lang="scss" scoped>
  .header {
    width: 100%;
    position: fixed;
    z-index: 99;
    .el-menu {
      width: 100%;
      min-width: 500px;
      border-radius: 0;
      .menuSub {
        flex: 6;
        position: relative;
      }
      .logo {
        color: white;
        position: relative;
        display: inline-block;
        margin: 16px 32px;
        font-size: 20px;
      }
      .right-menu{
        float: right;
      }
    }
  }

  .el-menu--horizontal{
    .logout{
      text-decoration: none;
      display:inline-block;
      width: 100%;
      text-align: center;
      color: black;
    }
  }

</style>
